import { BreadcrumbNameLoaderType } from "../../../../services/breadcrumbs/breadcrumbLoaders/breadcrumbNameLoaders/BreadcrumbNameLoaderType";
import { ConflictManagementBreadcrumbNameLoader } from "./ConflictManagementBreadcrumbNameLoader";
import { ContractBreadcrumbNameLoader } from "./ContractBreadcrumbNameLoader";
import { InstallChecklistBreadcrumbNameLoader } from "./InstallChecklistBreadcrumbNameLoader";
import { ProductBreadcrumbNameLoader } from "./ProductBreadcrumbNameLoader";
import { UserRolesBreadcrumbNameLoader } from "./UserRolesBreadcrumbNameLoader";
import { AdminViewBreadcrumbNameLoader } from "./AdminViewBreadcrumbNameLoader";
import { AdminViewLicenseLogBreadcrumbNameLoader } from "./AdminViewLicenseLogBreadcrumbNameLoader";
import { AdminViewDownloadHistoryBreadcrumbNameLoader } from "./AdminViewDownloadHistoryBreadcrumbNameLoader";
import { AdminViewProductMappingBreadcrumbNameLoader } from "./AdminViewProductMappingBreadcrumbNameLoader";
import { AdminViewProjectTableBreadcrumbNameLoader } from "./AdminViewProjectTableBreadcrumbNameLoader";
import { AdminViewCustomerTableBreadcrumbNameLoader } from "./AdminViewCustomerTableBreadcrumbNameLoader";
import { AdminViewReleasesBreadcrumbNameLoader } from "./AdminViewReleasesBreadcrumbNameLoader";
import { AdminViewProjectAnalysisBreadcrumbNameLoader } from "./AdminViewProjectAnalysisBreadcrumbNameLoader";
import { AdminViewUpdateSyncBreadcrumbNameLoader } from "./AdminViewUpdateSyncBreadcrumbNameLoader";
import { AdminViewEmailLogsBreadcrumbNameLoader } from "./AdminViewEmailLogsBreadcrumbNameLoader";

/**
 * This list is responsible for providing all {@link BreadcrumbNameLoaderType}s
 * to ensure that e.g. entities and their ids can be mapped to a readable format.
 */
export const BreadcrumbNameLoaderTypes: BreadcrumbNameLoaderType[] = [
  ConflictManagementBreadcrumbNameLoader,
  ContractBreadcrumbNameLoader,
  InstallChecklistBreadcrumbNameLoader,
  ProductBreadcrumbNameLoader,
  UserRolesBreadcrumbNameLoader,
  AdminViewBreadcrumbNameLoader,
  AdminViewLicenseLogBreadcrumbNameLoader,
  AdminViewDownloadHistoryBreadcrumbNameLoader,
  AdminViewProductMappingBreadcrumbNameLoader,
  AdminViewProjectTableBreadcrumbNameLoader,
  AdminViewCustomerTableBreadcrumbNameLoader,
  AdminViewReleasesBreadcrumbNameLoader,
  AdminViewProjectAnalysisBreadcrumbNameLoader,
  AdminViewUpdateSyncBreadcrumbNameLoader,
  AdminViewEmailLogsBreadcrumbNameLoader,
];
